"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var SENSOR_TEMPERATURE = 'TEMPERATURE';
var SENSOR_CURRENT = 'CURRENT';
var SENSOR_DENSITY = 'DENSITY';
var SENSOR_ENERGY = 'ENERGY';
var SENSOR_FLOW = 'FLOW';
var SENSOR_LEVEL = 'LEVEL';
var SENSOR_POWER = 'POWER';
var SENSOR_PRESSURE = 'PRESSURE';
var SENSOR_SPEED = 'SPEED';
var SENSOR_TIME = 'TIME';
var SENSOR_VALVE = 'VALVE';
var SENSOR_VISCOSITY = 'VISCOSITY';
var OPERATING_HOURS = 'OPERATING_HOURS';
var mill = {
  speed: {
    unit: 'rpm',
    mapValue: SENSOR_SPEED,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 0,
    visualization: {
      yMin: null,
      yMax: null
    }
  },
  current: {
    unit: 'A',
    mapValue: SENSOR_CURRENT,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: null,
      yMax: null
    }
  },
  power: {
    unit: 'kW',
    mapValue: SENSOR_POWER,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: null,
      yMax: null
    }
  },
  grinding_chamber_pressure: {
    unit: 'bar',
    mapValue: SENSOR_PRESSURE,
    trigger: ['min', 'max'],
    period: '5s',
    decimalPlace: 1,
    visualization: {
      yMin: 0,
      yMax: 4
    }
  },
  product_out_temperature: {
    unit: 'C',
    mapValue: SENSOR_TEMPERATURE,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: 0,
      yMax: 100
    }
  },
  grinding_energy: {
    unit: 'kWh',
    mapValue: SENSOR_ENERGY,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: null,
      yMax: null
    }
  },
  uptime: {
    unit: 'h',
    mapValue: SENSOR_TIME,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 0,
    visualization: {
      yMin: 0,
      yMax: null
    }
  },
  feeding_pump_speed: {
    unit: 'rpm',
    mapValue: SENSOR_SPEED,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 0,
    visualization: {
      yMin: 0,
      yMax: 1000
    }
  },
  feeding_valve_openness: {
    unit: '%',
    mapValue: SENSOR_VALVE,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 0,
    visualization: {
      yMin: 0,
      yMax: 100
    }
  },
  peripheral_speed: {
    unit: 'm/s',
    mapValue: SENSOR_SPEED,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: 0,
      yMax: 18
    }
  },
  feeding_pump_current: {
    unit: 'A',
    mapValue: SENSOR_CURRENT,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: null,
      yMax: null
    }
  },
  product_in_temperature: {
    unit: 'C',
    mapValue: SENSOR_TEMPERATURE,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: 0,
      yMax: 100
    }
  },
  product_flow_speed: {
    unit: 'l/h',
    mapValue: SENSOR_FLOW,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: null,
      yMax: null
    },
    subIdent: {
      '01': {
        unit: 'l/min',
        postfix: 'l/min'
      }
    }
  },
  water_cooling_inlet_temperature: {
    unit: 'C',
    mapValue: SENSOR_TEMPERATURE,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: 0,
      yMax: 100
    }
  },
  water_cooling_chamber_temperature: {
    unit: 'C',
    mapValue: SENSOR_TEMPERATURE,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: 0,
      yMax: 100
    }
  },
  water_cooling_chamber_flow_speed: {
    unit: 'l/h',
    mapValue: SENSOR_FLOW,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: 0,
      yMax: 100
    },
    subIdent: {
      '01': {
        unit: 'l/min',
        postfix: 'l/min'
      }
    }
  },
  seal_level: {
    unit: '%',
    mapValue: SENSOR_LEVEL,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 0,
    visualization: {
      yMin: 0,
      yMax: 100
    }
  },
  seal_air_pressure: {
    unit: 'bar',
    mapValue: SENSOR_PRESSURE,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: 0,
      yMax: 6
    }
  },
  seal_temperature: {
    unit: 'C',
    mapValue: SENSOR_TEMPERATURE,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: 0,
      yMax: 100
    }
  },
  seal_flow_speed: {
    unit: 'l/h',
    mapValue: SENSOR_FLOW,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: 0,
      yMax: 200
    },
    subIdent: {
      '01': {
        unit: 'l/min',
        postfix: 'l/min'
      }
    }
  },
  water_cooling_seal_temperature: {
    unit: 'C',
    mapValue: SENSOR_TEMPERATURE,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: 0,
      yMax: 100
    }
  },
  water_cooling_shaft_temperature: {
    unit: 'C',
    mapValue: SENSOR_TEMPERATURE,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: 0,
      yMax: 10
    }
  },
  water_cooling_shaft_flow_speed: {
    unit: 'l/h',
    mapValue: SENSOR_FLOW,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: null,
      yMax: null
    },
    subIdent: {
      '01': {
        unit: 'l/min',
        postfix: 'l/min'
      }
    }
  },
  fixed_bearing_temperature: {
    unit: 'C',
    mapValue: SENSOR_TEMPERATURE,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: 0,
      yMax: 100
    }
  },
  rotary_bearing_temperature: {
    unit: 'C',
    mapValue: SENSOR_TEMPERATURE,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: 0,
      yMax: 100
    }
  },
  mixer_speed: {
    unit: 'rpm',
    mapValue: SENSOR_SPEED,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 0,
    visualization: {
      yMin: null,
      yMax: null
    }
  },
  mixer_current: {
    unit: 'A',
    mapValue: SENSOR_CURRENT,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: null,
      yMax: null
    }
  },
  mixer_power: {
    unit: 'kW',
    mapValue: SENSOR_POWER,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: null,
      yMax: null
    }
  },
  discharge_pump_speed: {
    unit: 'rpm',
    mapValue: SENSOR_SPEED,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 0,
    visualization: {
      yMin: null,
      yMax: null
    }
  },
  discharge_pump_current: {
    unit: 'A',
    mapValue: SENSOR_CURRENT,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: null,
      yMax: null
    }
  },
  dynamic_viscosity: {
    unit: 'cP',
    mapValue: SENSOR_VISCOSITY,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 0,
    visualization: {
      yMin: null,
      yMax: null
    }
  },
  product_density: {
    unit: 'g/cm3',
    mapValue: SENSOR_DENSITY,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: 0,
      yMax: 4
    }
  },
  coolant_batch_tank_temperature: {
    unit: 'C',
    mapValue: SENSOR_TEMPERATURE,
    trigger: ['min', 'max'],
    period: '30s',
    decimalPlace: 1,
    visualization: {
      yMin: 0,
      yMax: 100
    }
  }
};
var pump = {
  operating_hours: {
    unit: 'h',
    mapValue: OPERATING_HOURS,
    trigger: ['min', 'max'],
    period: '15s',
    decimalPlace: 0,
    visualization: {
      yMin: 0,
      yMax: null
    }
  }
};
var _default = exports["default"] = {
  mill: mill,
  pump: pump,
  unknown: {
    unit: 'n/a',
    mapValue: 'SENSOR_UNKNOWN',
    period: '30s',
    decimalPlace: 0,
    visualization: {
      yMin: null,
      yMax: null
    }
  }
};